<script setup lang="ts">
/*
 * FILE: unified_ui/src/components/SubscribeGate.vue
 * PURPOSE: Full-screen Telegram channel subscription gate — rendered instead of
 *          the app shell + onboarding until the user joins @cyberholding.
 * OWNS: subscribe screen UI, manual recheck trigger.
 * EXPORTS: SubscribeGate (no props/emits — visibility driven by the gate store,
 *          which App.vue reads)
 * DOCS: .agents/reports/plan_subscribe-gate_2026-08-11.md
 */
import { onMounted, ref } from 'vue'
import { useGateStore } from '@/stores/gate'
import { trackEvent } from '@/lib/trackEvent'

const gate = useGateStore()
const checking = ref(false)

// The gate mounts exactly when the blocking screen is shown — "seen the
// subscribe wall" is a beat of the user's path (fires on every blocked
// session / re-block within a session).
onMounted(() => {
  trackEvent('subscribe-gate-shown')
})

async function onRecheck() {
  if (checking.value) return
  checking.value = true
  try {
    await gate.recheck()
  } finally {
    checking.value = false
  }
}
</script>

<template>
  <div
    class="fixed inset-0 z-50 overflow-y-auto bg-slate-900/60 backdrop-blur-sm dark:bg-slate-950/70"
    data-testid="subscribe-gate"
  >
    <div class="flex min-h-full items-center justify-center p-4">
      <div class="card-heavy w-full max-w-md p-6 text-center md:p-8">
        <h1 class="text-2xl font-semibold text-ink-900 dark:text-slate-100">📺 Подпишитесь на @cyberholding</h1>

        <div class="mt-6 space-y-4">
          <a
            href="https://t.me/cyberholding"
            target="_blank"
            rel="noopener"
            class="btn-primary block w-full"
          >
            Подписаться на канал
          </a>
          <button type="button" class="btn-ghost w-full" :disabled="checking" @click="onRecheck">
            ✅ Я подписался
          </button>
        </div>

        <p class="mt-6 text-sm text-ink-500 dark:text-slate-400">
          Статус проверяется автоматически при возврате в приложение
        </p>
      </div>
    </div>
  </div>
</template>
